'use strict';

angular.module('upResources').factory('AccountRelation', [
	'$resource',
	'$q',
	'URL',
	'API',
	'ResourceHelper',
	function ContactCategory($resource, $q, URL, API, ResourceHelper) {
		var helper = new ResourceHelper();

		// Set entity-specific defaults here
		helper.setDefaults({
			eventPrefix: 'accountRelation',
			createSuccessBody: 'saved.relation',
			updateSuccessBody: 'updated.relation',
			deleteSucccessTitle: 'default.saved',
			deleteSucccessBody: 'deleted.relation',
			createErrorBody: 'saveError.relation',
			updateErrorBody: 'saveError.relation',
			deleteErrorBody: 'deleteError.relation'
		});

		var Model = {
			customer: function (customer) {
				var instance = {};
				var AccountRelation = null;

				AccountRelation = $resource(
					URL + API + customer + '/clientrelations/:id',
					{},
					{
						query: { method: 'GET', isArray: false },
						create: { method: 'POST', isArray: false },
						get: { method: 'GET' },
						update: { method: 'PUT', isArray: false }
					}
				);

				var Descriptions = $resource(
					URL + API + customer + '/clientrelations/descriptions',
					{},
					{ query: { method: 'GET', isArray: false } }
				);

				instance.save = function (relation, options) {
					var method = 'create';

					if (relation.id) {
						method = 'update';
					}

					return AccountRelation[method]({ id: relation.id }, relation)
						.$promise.then(function (res) {
							// Notify user
							helper.onSave(options, res.data, !relation.id);

							return res;
						})
						.catch(function (err) {
							// Notify user
							helper.onSaveError(options, !relation.id, err);
							return $q.reject(err);
						});
				};

				instance.get = function (id) {
					return AccountRelation.get({ id: id }).$promise;
				};

				// Relation labels already in use in this account, most used first.
				instance.getDescriptions = function () {
					return Descriptions.query().$promise.then(function (res) {
						return res.data || [];
					});
				};

				instance['delete'] = function (relation, options) {
					return AccountRelation.delete({ id: relation.id })
						.$promise.then(function (res) {
							// Notify user
							helper.onDelete(options, relation);

							return res;
						})
						.catch(function () {
							// Notify user
							helper.onDeleteError(options);
						});
				};

				return instance;
			}
		};

		return Model;
	}
]);
